import { EstimateService } from "../../../models/estimate";

export interface ServiceColumn {
  key: keyof EstimateServiceColumns;
  name: string;
  style: React.CSSProperties;
  className: string;
}

export interface EstimateServiceColumns extends Omit<EstimateService, "serviceId" | "currencyId"> {
  subTotal?: number;
  actions?: unknown;
}

export interface AllowedColumn {
  column: keyof EstimateServiceColumns;
  style?: React.CSSProperties;
  className?: string;
}

export enum KeyboardKey {
  ENTER = "Enter",
  ESCAPE = "Escape",
}

export enum IconColor {
  DISABLED = "#D0D5DD",
  DANGER = "#D92D20",
  NORMAL = "",
}

export type ValueOf<T> = T[keyof T];
